export const localStorageKeys={
    ACCESS_TOKEN:"ACCESS_TOKEN",
    USER:"USER"

}

//export const SERVER_URL='http://209.97.142.89:3000/'//http://192.168.0.45:3000
export const SERVER_URL='https://www.ajmeddy.com/api/'